export const AllProjects = [
  // {
  //   id: 1,
  //   name: "Car Deal Application",
  //   type: "Car Selling Website",
  //   image1: "https://i.postimg.cc/QdLHDdVz/car-1.png",
  //   image2: "https://i.postimg.cc/MHNXvW5v/car-2.png",
  //   image3: "https://i.postimg.cc/9fY4JHmn/car-3.png",
  //   image4: "https://i.postimg.cc/vBP4w767/car-4.png",
  //   shortDescription:
  //     "This is a full stack website. This is a car selling web application.",
  //   description1:
  //     "User Can Buy a Car and Billing for purchase car and User can gives a review.",
  //   description2:
  //     "User create his account by sign up, after he sign in for billing a car.",
  //   description3:
  //     "Buyer can see his order on his dashboard and he can gives review.",
  //   description4:
  //     "Admin manage order, manage products, make an admin another person.",
  //   description5: "Buyer can order car and deal with admin panel.",
  //   duration: "10th Nov to 14th Nov, 2021",
  //   technology1: "React",
  //   technology2: "React-Bootstrap",
  //   technology3: "Firebase",
  //   technology4: "Node",
  //   technology5: "Express",
  //   technology6: "MongoDB",
  //   technology7: "Heroku",
  //   technology8: "Netlify",
  //   clientCode: "https://github.com/MD-Mehedi-Hasan18111/car-deal-client-side",
  //   serverCode: "https://github.com/MD-Mehedi-Hasan18111/car-deal-server-side",
  //   liveSite: "https://car-deal-me.netlify.app/",
  // },

  // {
  //   id: 2,
  //   name: "Softy Shop",
  //   type: "E-commerce Website",
  //   image1: "https://i.postimg.cc/nL8F6rxM/softy-shop-1.jpg",
  //   image2: "https://i.postimg.cc/q7fKjpZx/softy-shop-2.jpg",
  //   image3: "https://i.postimg.cc/MKNfpWxJ/softy-shop-3.jpg",
  //   image4: "https://i.postimg.cc/ZqTbTg9h/softy-shiop-4.jpg",
  //   shortDescription:
  //     "This is a E-commerce website. Customer get the service for market of this site.",
  //   description1: "User Can Buy Product above from the menu of header.",
  //   description2: "User can see product detail by clicking the product card.",
  //   description3: "User can product add to wishlist for buy future.",
  //   description4: "User can increment decrement product quantity in the cart.",
  //   description5: "User and admin have individual dashboard.",
  //   duration: "10th Nov to 14th Nov, 2021",
  //   technology1: "React",
  //   technology2: "React-Bootstrap",
  //   technology3: "Redux",
  //   technology4: "Firebase",
  //   technology5: "Node & Express",
  //   technology6: "MongoDB",
  //   technology7: "Heroku",
  //   technology8: "Netlify",
  //   clientCode: "https://github.com/MD-Mehedi-Hasan18111/softy-shop-client",
  //   serverCode: "https://github.com/MD-Mehedi-Hasan18111/softy-server",
  //   liveSite: "https://zen-golick-b097b5.netlify.app/",
  // },

  // {
  //   id: 3,
  //   name: "Technology Store Web Application",
  //   type: "Computer shop website",
  //   image1: "https://i.postimg.cc/FKy8WsGy/tech-store-1.jpg",
  //   image2: "https://i.postimg.cc/vHxP2ZZ4/tech-store-2.jpg",
  //   image3: "https://i.postimg.cc/ZYXk5g9y/tech-store-3.jpg",
  //   image4: "https://i.postimg.cc/9X6Sh7Sd/tech-store-4.jpg",
  //   shortDescription:
  //     "This is a full stack website. This is computer shop related web application.",
  //   description1:
  //     "Products can be seen by dropdown selecting each brand's products in the Top Product section.",
  //   description2:
  //     "Product cards have to be clickable. When clicking the card it goes to the product details route.",
  //   description3:
  //     "This website has a dashboard for buyers. Buyer can see his order in the dashboard and he can give reviews of products.",
  //   description4:
  //     "Is there an authentication system email password and google sign in.",
  //   description5: "Buyer can payment his order by via Stripe.",
  //   duration: "17th Dec to 21th Dec, 2021",
  //   technology1: "React",
  //   technology2: "React-Bootstrap",
  //   technology3: "Firebase",
  //   technology4: "Node & Express",
  //   technology5: "MongoDB",
  //   technology6: "Stripe",
  //   technology7: "Heroku",
  //   technology8: "Netlify",
  //   clientCode:
  //     "https://github.com/MD-Mehedi-Hasan18111/technology-store-client",
  //   serverCode:
  //     "https://github.com/MD-Mehedi-Hasan18111/technology-store-server",
  //   liveSite: "https://technology-store-me.netlify.app/",
  // },

  {
    id: 4,
    name: "Red Onion Application",
    type: "Restaurant Website",
    image1: "https://i.postimg.cc/nLJj4hJm/3.png",
    image2: "https://i.postimg.cc/wxG1WVzg/red-2.png",
    image3: "https://i.postimg.cc/yd6DGpWY/red-3.png",
    image4: "https://i.postimg.cc/6qyyW7dk/red-4.png",
    shortDescription:
      "Restaurant website building by React Js. Full responsive and state managed by Context.",
    description1:
      "User can see dinner, lunch, breakfast items individually on home page.",
    description2:
      "User can sign in with google and he can sign up by email and password.",
    description3: "Client can order food and purchase it.",
    description4: "Customer when ordering food before shipping order.",
    description5: "Customer information store by the shipping form.",
    duration: "10th Oct to 30th Oct, 2021",
    technology1: "React",
    technology2: "React-Bootstrap",
    technology3: "Firebase",
    technology4: "Context API",
    technology5: "Netlify",
    technology6: "",
    technology7: "",
    technology8: "",
    clientCode: "https://github.com/MD-Mehedi-Hasan18111/red-onion-restaurant",
    serverCode: "",
    liveSite: "https://red-onion-restaurant-me.netlify.app/",
  },

  // {
  //   id: 5,
  //   name: "RedX Courier Application",
  //   type: "Delivery Website",
  //   image1: "https://i.postimg.cc/W1rqqJQj/2.png",
  //   image2: "https://i.postimg.cc/pdRr9cfY/redx-2.png",
  //   image3: "https://i.postimg.cc/Fsk7wLFc/redx-3.png",
  //   image4: "https://i.postimg.cc/T3rh3vD3/redx-4.png",
  //   shortDescription:
  //     "This is a full stack website. This is delivery related web application.",
  //   description1: "Client Booking a Service for Delivery Products.",
  //   description2: "User can see his total booking of order in his dashboard.",
  //   description3:
  //     "Customer can see his registered service as pending or approved still.",
  //   description4: "Admin can add a new service on this application.",
  //   description5: "An Admin can Manage all registered service.",
  //   duration: "17th Oct to 19th Oct, 2021",
  //   technology1: "React",
  //   technology2: "React-Bootstrap",
  //   technology3: "Firebase",
  //   technology4: "Node",
  //   technology5: "Express",
  //   technology6: "MongoDB",
  //   technology7: "Heroku",
  //   technology8: "Netlify",
  //   clientCode: "https://github.com/MD-Mehedi-Hasan18111/courier-client-side",
  //   serverCode: "https://github.com/MD-Mehedi-Hasan18111/courier-server-side",
  //   liveSite: "https://redx-courier.netlify.app/",
  // },

  {
    id: 6,
    name: "Rock Paper Scissor Game",
    type: "JavaScript Web Game",
    image1: "https://i.postimg.cc/nrJCqp9r/rock-1.png",
    image2: "https://i.postimg.cc/qMpNRBdZ/rock-2.png",
    image3: "https://i.postimg.cc/RV22dhVg/rock-3.png",
    image4: "https://i.postimg.cc/zf7dsG8Z/rock-4.png",
    shortDescription:
      "A simple rock paper scissor game built by pure JavaScript and DOM manipulation.",
    description1: "User played with Computer auto play.",
    description2: "This game is over in 10 points.",
    description3: "Who gain 10 points first he is the win of match.",
    description4: "User clicking the image for turn game.",
    description5:
      "Game over message and winning message given by alert message.",
    duration: "20th April to 21th April, 2021",
    technology1: "HTML",
    technology2: "CSS",
    technology3: "Bootstrap",
    technology4: "JavaScript",
    technology5: "Netlify",
    technology6: "",
    technology7: "",
    technology8: "",
    clientCode:
      "https://github.com/MD-Mehedi-Hasan18111/rock-paper-scissor-game",
    serverCode: "",
    liveSite: "https://rock-paper-scissor-me.netlify.app/",
  },

  {
    id: 7,
    name: "Spreedsheets data analyst",
    type: "AI - powered tool",
    image1: "https://i.ibb.co.com/LXJfcXrp/home.png",
    image2: "https://i.ibb.co.com/RTRDZ9Vk/analysis.png",
    image3: "https://i.ibb.co.com/YFdvDZGk/reconcile.png",
    image4: "https://i.ibb.co.com/fYyLtR8T/board.png",
    shortDescription: "Spreadsheet data analyst reduce your work time.",
    description1:
      "Upload a spreadsheet, provide instructions, and instantly get the analyzed data or visualization by chart and audio presentations.",
    description2:
      "Create your reusable pipelines for reconciling data, Set up a pipeline once, and reuse it multiple times for similar data structures.",
    description3:
      "Craft compelling stories and effectively communicate your ideas and visualizations using a Reef Board",
    description4: "",
    description5: "",
    duration: "October 2024 - present",
    technology1: "Next JS 14",
    technology2: "Tailwind CSS",
    technology3: "Reduxt Toolkit",
    technology4: "Context API",
    technology5: "Typescript",
    technology6: "Python",
    technology7: "Open AI",
    technology8: "",
    clientCode: "",
    serverCode: "",
    liveSite: "https://app.reef.lat",
  },
];
